module.exports = __webpack_public_path__ + "static/media/testAmountGif.4e9d7e96.gif";